//次梁合并拆分按钮
let mergeSplitButton = null;
let clickMergeType = false;
let clickSplitType = false;
let clickCancelType = false;
let isDragging = false;
let startX = 0;
let startY = 0;
let currentX = 0;
let currentY = 0;
let m_mergeBtnName = "合并";
let m_SplitBtnName = "拆分";

import store from "@/store";
import { Message } from "element-ui";
import { name } from "file-loader";

// 拖动相关函数
const handleDragStart = (e) => {
  isDragging = true;
  if (e.type === "mousedown") {
    startX = e.clientX - mergeSplitButton.offsetLeft;
    startY = e.clientY - mergeSplitButton.offsetTop;
  } else if (e.type === "touchstart") {
    startX = e.touches[0].clientX - mergeSplitButton.offsetLeft;
    startY = e.touches[0].clientY - mergeSplitButton.offsetTop;
  }
};

const handleDragMove = (e) => {
  if (!isDragging) return;

  if (e.type === "mousemove") {
    currentX = e.clientX - startX;
    currentY = e.clientY - startY;
  } else if (e.type === "touchmove") {
    currentX = e.touches[0].clientX - startX;
    currentY = e.touches[0].clientY - startY;
  }

  // 限制在视口范围内
  const maxX = window.innerWidth - mergeSplitButton.offsetWidth;
  const maxY = window.innerHeight - mergeSplitButton.offsetHeight;

  currentX = Math.max(0, Math.min(currentX, maxX));
  currentY = Math.max(0, Math.min(currentY, maxY));

  mergeSplitButton.style.left = currentX + "px";
  mergeSplitButton.style.top = currentY + "px";
};

const handleDragEnd = () => {
  isDragging = false;
};

//获取按钮
export const getMergeSplitButton = () => {
  return mergeSplitButton;
};

//创建按钮
export const createMergeSplitButton = (
  mergeBtnName = "合并",
  SplitBtnName = "拆分",
  showMerge = true,
  showSplit = true
) => {
  m_mergeBtnName = mergeBtnName;
  m_SplitBtnName = SplitBtnName;
  mergeSplitButton = document.createElement("div");
  mergeSplitButton.className = "rl-merge-split-button";

  // 设置基本样式
  mergeSplitButton.style.cssText = `
    position: fixed !important;
    top: 50px !important;
    right: 50px !important;
    z-index: 99999 !important;
    display: inline-flex !important;
    flex-direction: row !important;
    gap: 4px !important;
    background: rgba(255, 255, 255, 0.9) !important;
    padding: 4px !important;
    border-radius: 4px !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
    backdrop-filter: blur(2px) !important;
    width: fit-content !important;
    user-select: none !important;
    -webkit-user-select: none !important;
    touch-action: none !important;
  `;

  // 创建拖动区域
  const dragHandle = document.createElement("div");
  dragHandle.style.cssText = `
    width: 20px !important;
    height: 24px !important;
    background: rgba(0, 0, 0, 0.1) !important;
    border-radius: 3px !important;
    cursor: move !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 4px !important;
    touch-action: none !important;
  `;

  // 添加拖动图标
  const dragIcon = document.createElement("div");
  dragIcon.style.cssText = `
    width: 12px !important;
    height: 12px !important;
    background: repeating-linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.3) 0px,
      rgba(0, 0, 0, 0.3) 1px,
      transparent 1px,
      transparent 4px
    ) !important;
    border-radius: 2px !important;
  `;
  dragHandle.appendChild(dragIcon);

  // 创建按钮
  const createButton = (text, type, isVisible = true) => {
    const button = document.createElement("button");
    button.innerHTML = text;
    button.style.cssText = `
      width: 60px !important;
      height: 24px !important;
      border: none !important;
      border-radius: 3px !important;
      cursor: pointer !important;
      font-size: 12px !important;
      display: ${isVisible ? "block" : "none"} !important;
      transition: all 0.2s ease !important;
      font-weight: 500 !important;
      letter-spacing: 0.5px !important;
      text-align: center !important;
      line-height: 24px !important;
      padding: 0 !important;
      margin: 0 !important;
      box-shadow: 0 1px 2px rgba(0,0,0,0.1) !important;
      flex-shrink: 0 !important;
      touch-action: none !important;
    `;

    if (type === "primary") {
      button.style.cssText += `
        background: linear-gradient(135deg, #409EFF, #337ecc) !important;
        color: #fff !important;
      `;
    } else {
      button.style.cssText += `
        background: linear-gradient(135deg, #909399, #6b6d71) !important;
        color: #fff !important;
      `;
    }

    // 添加悬停效果
    button.addEventListener("mouseover", () => {
      button.style.transform = "scale(1.05)";
      button.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
    });

    button.addEventListener("mouseout", () => {
      button.style.transform = "scale(1)";
      button.style.boxShadow = "0 1px 2px rgba(0,0,0,0.1)";
    });

    // 添加点击效果
    button.addEventListener("mousedown", () => {
      button.style.transform = "scale(0.95)";
    });

    button.addEventListener("mouseup", () => {
      button.style.transform = "scale(1)";
    });

    return button;
  };

  // 创建三个按钮
  const mergeButton = createButton(mergeBtnName, "primary", showMerge);
  const splitButton = createButton(SplitBtnName, "primary", showSplit);
  const cancelButton = createButton("取消", "info");

  // 添加点击事件
  mergeButton.addEventListener("click", (e) => {
    e.stopPropagation(); // 阻止冒泡
    clickMergeType = true;
    // 触发自定义事件，通知父组件执行清理
    window.dispatchEvent(
      new CustomEvent("mergeSplitButtonClick", {
        detail: { type: "merge", name: m_mergeBtnName },
      })
    );
  });

  splitButton.addEventListener("click", (e) => {
    e.stopPropagation(); // 阻止冒泡
    clickSplitType = true;
    // 触发自定义事件，通知父组件执行清理
    window.dispatchEvent(
      new CustomEvent("mergeSplitButtonClick", {
        detail: { type: "split", name: m_SplitBtnName },
      })
    );
  });

  cancelButton.addEventListener("click", (e) => {
    e.stopPropagation(); // 阻止冒泡
    clickCancelType = true;
    // 触发自定义事件，通知父组件执行清理
    window.dispatchEvent(
      new CustomEvent("mergeSplitButtonClick", { detail: { type: "cancel" } })
    );
  });
  // 添加拖动事件监听器到拖动区域
  dragHandle.addEventListener("mousedown", handleDragStart);
  dragHandle.addEventListener("touchstart", handleDragStart, {
    passive: false,
  });
  document.addEventListener("mousemove", handleDragMove);
  document.addEventListener("mouseup", handleDragEnd);
  document.addEventListener("touchmove", handleDragMove, { passive: false });
  document.addEventListener("touchend", handleDragEnd);

  // 添加拖动区域和按钮到容器
  mergeSplitButton.appendChild(dragHandle);
  mergeSplitButton.appendChild(mergeButton);
  mergeSplitButton.appendChild(splitButton);
  mergeSplitButton.appendChild(cancelButton);

  // 添加到body
  if (document.body) {
    document.body.appendChild(mergeSplitButton);
  }

  return mergeSplitButton;
};

//获取点击状态
export const getClickMergeType = () => {
  return clickMergeType;
};

export const getClickSplitType = () => {
  return clickSplitType;
};

export const getClickCancelType = () => {
  return clickCancelType;
};
//设置点击状态
export const setClickMergeType = (type) => {
  clickMergeType = type;
};

export const setClickSplitType = (type) => {
  clickSplitType = type;
};

export const setClickCancelType = (type) => {
  clickCancelType = type;
};

//销毁按钮
export const destroyMergeSplitButton = () => {
  if (mergeSplitButton) {
    // 移除事件监听器
    document.removeEventListener("mousemove", handleDragMove);
    document.removeEventListener("mouseup", handleDragEnd);
    document.removeEventListener("touchmove", handleDragMove);
    document.removeEventListener("touchend", handleDragEnd);

    mergeSplitButton.remove();
    mergeSplitButton = null;
  }
  clickMergeType = false;
  clickSplitType = false;
  clickCancelType = false;
};

//修改按钮位置
export const setMergeSplitButtonPosition = (x, y) => {
  if (!mergeSplitButton) {
    return;
  }
  // 坐标转换
  const selectObjPoint = rlAppObj._rlMx.MxFun.cadCoord2Doc(x, y);
  // 将文档坐标转换为屏幕坐标
  const pxPoint = rlAppObj._rlMx.MxFun.docCoord2Screen(
    selectObjPoint.x,
    selectObjPoint.y
  );
  mergeSplitButton.style.left = pxPoint.x + "px";
  mergeSplitButton.style.top = pxPoint.y + "px";
};
